// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-range__track--active {
    background-color: #A046D3;
}

.input-range__slider {
    background-color: #A046D3;
    border: 1px solid #A046D3;
    background-clip: content-box
}

.min100 { 
    min-width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/pages/template/templates-filter.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB;AACJ;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".input-range__track--active {\n    background-color: #A046D3;\n}\n\n.input-range__slider {\n    background-color: #A046D3;\n    border: 1px solid #A046D3;\n    background-clip: content-box\n}\n\n.min100 { \n    min-width: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
